import { transformCatalogSectionItemToProductCard } from '@components/Product/components/ProductCard/utils/mountItemToProductCard.utils';
import ProductCardV2 from '@components/Product/components/ProductCardV2/ProductCardV2';
import { SaleItemType } from '@components/Search/interfaces/product-action.dto';
import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import useSuggestedProducts from './hooks/useSuggestedProducts';
import { useSuggestedProductsStyles } from './suggestedProducts.styles';
import { SuggestedProductsProps } from './suggestedProducts.types';

const SuggestedProducts = ({
  productId,
  productColorId,
  isOfflineMode = false,
}: SuggestedProductsProps) => {
  const { translate } = useTranslation();
  const { columns, isEmpty, isHidden, products, setGridElement, setLoadMoreElement } =
    useSuggestedProducts({ productId, productColorId, isOfflineMode });
  const { classes } = useSuggestedProductsStyles({ columns });

  const renderContent = () => {
    if (isHidden || isEmpty) {
      return (
        <div className={classes.emptyState}>
          <Typography variant="body2" color="text.secondary">
            {translate(LangEnum.GLOBAL_NO_RESULTS)}
          </Typography>
        </div>
      );
    }

    return (
      <div ref={setGridElement} className={classes.grid}>
        {products.map((product) => (
          <div key={product.productColorId} className={classes.card}>
            <ProductCardV2
              visibility={{ showPrices: false }}
              item={transformCatalogSectionItemToProductCard({
                ...product,
                type: SaleItemType.ELASTIC_PRODUCT_COLOR,
              })}
            />
          </div>
        ))}

        <div ref={setLoadMoreElement} className={classes.loadMoreSentinel} />
      </div>
    );
  };

  return <section className={classes.container}>{renderContent()}</section>;
};

export default SuggestedProducts;
